import { Component, OnInit, OnDestroy, OnChanges, Input, HostListener, ElementRef } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { SMSBasic } from 'src/app/models/turns-models/turns-sms-basic.model';
import { Subscription } from 'rxjs';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { SmsValidChars } from 'src/app/validators/sms-valid-char.validator';
import { SmsService } from 'src/app/services/sms-service/smsservice';

@Component({
  selector: 'app-sms-sms-templates-info-card',
  templateUrl: './sms-sms-templates-info-card.component.html',
  styleUrls: ['./sms-sms-templates-info-card.component.scss']
})
export class SmsSmsTemplatesInfoCardComponent implements OnInit, OnChanges, OnDestroy {

  @Input() sms: SMSBasic;
  centerList;
  editingLocked: boolean;
  updateSmsTemplatesSubscription: Subscription;
  basicDataForm = new FormGroup({
    smsPickTurn: new FormControl({ value: null, disabled: true }, SmsValidChars),
    smsPickAppointment: new FormControl({ value: null, disabled: true }, SmsValidChars),
    smsPreviousTurn: new FormControl({ value: null, disabled: true }, SmsValidChars),
    smsArrivalTurn: new FormControl({ value: null, disabled: true }, SmsValidChars),
  });

  constructor(private smsService: SmsService,
    private eRef: ElementRef,
    private userStorageService: UserStorageService,
    private snackbarService: SnackBarService) {
      this.editingLocked = true;
    }

  ngOnInit() {
    this.centerList = this.userStorageService.getCenterList();
  }

  ngOnChanges() {
    if (this.sms) {
      this.resetForm();
    }
  }

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (this.eRef.nativeElement.contains(event.target)) {
    } else {
      if (event.path[0].className !== 'mat-option-text') {
        if (this.sms && !this.editingLocked) {
          this.resetForm();
          this.lockEdition();
        }
      }
    }
  }

  public toggleEdition() {
    if (this.editingLocked) {
      this.unlockEdition();
    } else {
      const validation = this.validateForm();
      if (validation === true) {
        this.submitForm();
      } else {
        this.snackbarService.open(validation, 'error');
      }
    }
  }

  public submitForm() {
    const validation = this.validateForm();
    if (validation) {
      this.updateSmsTemplatesSubscription = this.smsService.updateSmsTemplates(this.sms.InternalId, this.sms.Active, this.basicDataForm.get('smsPickAppointment').value, this.basicDataForm.get('smsPickTurn').value, this.basicDataForm.get('smsPreviousTurn').value, this.basicDataForm.get('smsArrivalTurn').value).subscribe(
        (res) => {
          this.snackbarService.open('sms-page.snackbar messages.update sms success', 'success');
          this.lockEdition();
        },
        (error) => {
          this.snackbarService.open(error['error']['message'], 'error');
        }
      );
    } else {
      this.snackbarService.open(validation, 'error');
    }
  }

  public validateForm() {
    if (!this.basicDataForm.get('smsPickTurn').valid) {
      return 'sms-page.snackbar messages.invalid characters';
    } else if (!this.basicDataForm.get('smsPreviousTurn').valid) {
      return 'sms-page.snackbar messages.invalid characters';
    } else if (!this.basicDataForm.get('smsArrivalTurn').valid) {
      return 'sms-page.snackbar messages.invalid characters';
    } else {
      return true;
    }
  }

  public resetForm() {
    this.basicDataForm.patchValue({
      smsPickTurn: this.sms.SmsPickTurn,
      smsPickAppointment: this.sms.SmsPickAppointment,
      smsPreviousTurn: this.sms.SmsPreviousTurn,
      smsArrivalTurn: this.sms.SmsArrivalTurn
    });
  }

  public unlockEdition() {
    this.basicDataForm.get('smsPickTurn').enable();
    this.basicDataForm.get('smsPickAppointment').enable();
    this.basicDataForm.get('smsPreviousTurn').enable();
    this.basicDataForm.get('smsArrivalTurn').enable();
    this.editingLocked = false;
  }

  public lockEdition() {
    this.basicDataForm.get('smsPickTurn').disable();
    this.basicDataForm.get('smsPickAppointment').disable();
    this.basicDataForm.get('smsPreviousTurn').disable();
    this.basicDataForm.get('smsArrivalTurn').disable();
    this.editingLocked = true;
  }

  public getSmsCharacters(field) {
    if (this.basicDataForm.get(field)) {
      const charactersLength = new Blob([this.basicDataForm.get(field).value]).size;
      if (charactersLength <= 160) {
        return [charactersLength, 'sms-page.sms characters'];
      } else if (charactersLength > 160) {
        return [Math.ceil(charactersLength / 160), 'sms-page.sms messages'];
      }
    }
  }

  ngOnDestroy() {
    if (this.updateSmsTemplatesSubscription) { this.updateSmsTemplatesSubscription.unsubscribe(); }
  }
}
